module.exports = __webpack_public_path__ + "img/J40-jordan.24aa9661.png";